import { render, staticRenderFns } from "./HsaBankLegalFooter.vue?vue&type=template&id=e4e239b2"
import script from "./HsaBankLegalFooter.vue?vue&type=script&lang=ts"
export * from "./HsaBankLegalFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports